export const LEAD_FEED_PROPERTY_TYPE = {
  sfr: 'SFR',
  condo: 'CONDO',
  manufactured: 'MANUFACTURED',
  multi: 'MULTI',
  townhouse: 'TOWNHOUSE',
  coop: 'COOP',
} as const;

export const TIME_SERIES_RESOLUTION = {
  Hour: 'hour',
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Quarter: 'quarter',
  Year: 'year',
} as const;
